import { useEffect, useState } from 'react';
import { usePrevious } from 'app/infrastructure/hooks';
import { Configuration } from 'app/components/metro-line/types';
import { DefaultFilterValidation } from 'app/area/shared/default-filters/types-store';
import { SavedReportsValidation } from 'app/area/shared/saved-reports/types-store';
import { CompanyReportItemValidation, TextsValidation, MetadataValidation, SavedReportCompanyReport } from '../types-store';
import { CompanyReportSectionType } from './types';

export const useInvalidSection = (
  configuration: Configuration<CompanyReportSectionType>[],
  validation: CompanyReportItemValidation,
  savedReportsValidation: SavedReportsValidation<SavedReportCompanyReport>,
  filterValidation: { [domainId: number]: DefaultFilterValidation },
  textsValidation: TextsValidation,
  metadataValidation: MetadataValidation
): [Configuration<CompanyReportSectionType>, React.Dispatch<React.SetStateAction<Configuration<CompanyReportSectionType>>>] => {

  const [invalidSection, updateInvalidSection] = useState(configuration.find(configurationSection => !configurationSection.isValid));
  const previousValidation = usePrevious(validation);
  const previousSavedReportsValidation = usePrevious(savedReportsValidation);
  const previousFilterValidation = usePrevious(filterValidation);
  const previousTextsValidation = usePrevious(textsValidation);
  const previousMetadataValidation = usePrevious(metadataValidation);

  useEffect(() => {
    if (invalidSection === undefined &&
      (validation !== previousValidation ||
        savedReportsValidation !== previousSavedReportsValidation ||
        filterValidation !== previousFilterValidation ||
        textsValidation !== previousTextsValidation ||
        metadataValidation !== previousMetadataValidation)
    ) {
      updateInvalidSection(configuration.find(configurationSection => !configurationSection.isValid));
    }
  }, [configuration, validation, savedReportsValidation, filterValidation, textsValidation, metadataValidation]);

  return [invalidSection, updateInvalidSection];
};
